import { useMemo } from 'react';

import { Stack, Typography } from '@mui/material';
import { Icon } from 'components-new';
import addZero from '@/utils/addZero';

type Props = {
  gameTime: number;
};

export const Time = ({ gameTime }: Props) => {
  const formattedTime = useMemo(() => {
    const date = new Date(gameTime);
    const hh = date.getUTCHours();
    const mm = date.getUTCMinutes();
    const ss = date.getUTCSeconds();
    return `${addZero(hh)}:${addZero(mm)}:${addZero(ss)}`;
  }, [gameTime]);

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Icon icon="fa-clock" />
      <Typography variant="h6">{formattedTime}</Typography>
    </Stack>
  );
};
